import type { InvoiceStatus } from '../api/invoices'

export const INVOICE_STATUS_COLORS: Record<InvoiceStatus, string> = {
  draft: '#9CA3AF', created: '#3B82F6', sent: '#8B5CF6',
  accepted: '#10B981', declined: '#EF4444', withdrawn: '#F59E0B', paid: '#059669',
}

export const INVOICE_STATUS_LABELS: Record<InvoiceStatus, string> = {
  draft: 'Draft', created: 'Created', sent: 'Sent',
  accepted: 'Accepted', declined: 'Declined', withdrawn: 'Withdrawn', paid: 'Paid',
}

export const INVOICE_NEXT_STATUSES: Record<InvoiceStatus, InvoiceStatus[]> = {
  draft: ['created'], created: ['sent'],
  sent: ['accepted', 'declined', 'withdrawn'], accepted: ['paid', 'withdrawn'],
  declined: [], withdrawn: [], paid: [],
}
